/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetAllSEGLookups: {
        $xmlns: 'http://dobs.pa.gov/dp/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetAllSEGLookups.Status.DP_LU_SEGStatus',
      'GetAllSEGLookups.IndividualTypes.DP_LU_SEGIndividualType',
      'GetAllSEGLookups.EntityTypes.DP_LU_SEGEntityType'
    ],
    blueprint: {
      status: [
        '$..DP_LU_SEGStatus',
        {
          id: '$.ID',
          status: '$.Status'
        }
      ],
      individualTypes: [
        '$..DP_LU_SEGIndividualType',
        {
          id: '$.ID',
          individualType: '$.IndividualType'
        }
      ],
      entityTypes: [
        '$..DP_LU_SEGEntityType',
        {
          id: '$.ID',
          entityType: '$.EntityType'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
